import * as React from "react";
import styled from "styled-components";

import { colors } from "../../styles/variables";

interface ContainerProps {
  accepted: boolean;
}

const StyledLabel = styled.div<ContainerProps>`
  display: inline-block;
  padding: 5px 10px;
  border-radius: 25px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.2px;
  color: ${props => (props.accepted ? colors.green.dark : colors.brand)};
  background-color: ${props => (props.accepted ? colors.green.light : "white")};
`;

interface Props {
  text: string;
  accepted: boolean;
}

const Label: React.SFC<Props> = ({ text, accepted }) => <StyledLabel accepted={accepted}>{text}</StyledLabel>;

export default Label;



// WEBPACK FOOTER //
// ./src/components/shared/Label.tsx